const adminEmailsRaw = import.meta.env.VITE_SUPER_ADMIN_EMAILS || "";
export const SUPER_ADMIN_EMAILS = adminEmailsRaw.split(",").map((e: string) => e.trim()).filter(Boolean);
